var render = function render(){
  var _vm$controller$turnst, _vm$controller$turnst2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.loading ? _c('loading-overlay') : _vm._e(), _c('title-row', {
    attrs: {
      "title": _vm.page.title,
      "subtitle": _vm.page.subtitle,
      "breadcrumb-items": [{
        text: 'Kontrollerek',
        to: {
          name: 'ControllerList'
        }
      }, _vm.page.breadcrumbItem]
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('title-row-button', {
          on: {
            "click": _vm.uploadCards
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-upload")]), _vm._v(" Kártyák feltöltése ")], 1), _c('title-row-button', {
          attrs: {
            "loading": _vm.saving
          },
          on: {
            "click": _vm.save
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-check")]), _vm._v(" Mentés ")], 1)];
      },
      proxy: true
    }])
  }), _c('v-card', {
    staticClass: "rounded-xl overflow-hidden",
    attrs: {
      "flat": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "align-tabs": "center",
      "color": "text--primary"
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "primary"
    }
  }), _c('v-tab', {
    key: "meta"
  }, [_vm._v(" Metaadatok ")]), !_vm.page.isNew ? [_c('v-tab', {
    key: "gates"
  }, [_vm._v(" Kapuk ")]), _c('v-tab', {
    key: "accumulators"
  }, [_vm._v(" Akkumulátorok ")]), _vm.controller.enabled > 0 ? _c('v-tab', {
    key: "debug"
  }, [_vm._v(" Hibakeresés ")]) : _vm._e()] : _vm._e(), _c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    key: "meta",
    attrs: {
      "transition": false
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("Alapadatok")]), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Megnevezés",
      "error-messages": _vm.errors.name,
      "filled": ""
    },
    model: {
      value: _vm.controller.name,
      callback: function ($$v) {
        _vm.$set(_vm.controller, "name", $$v);
      },
      expression: "controller.name"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Alias",
      "error-messages": _vm.errors.alias,
      "filled": ""
    },
    model: {
      value: _vm.controller.alias,
      callback: function ($$v) {
        _vm.$set(_vm.controller, "alias", $$v);
      },
      expression: "controller.alias"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Szériaszám",
      "error-messages": _vm.errors.serial_number,
      "filled": ""
    },
    model: {
      value: _vm.controller.serial_number,
      callback: function ($$v) {
        _vm.$set(_vm.controller, "serial_number", $$v);
      },
      expression: "controller.serial_number"
    }
  }), _c('v-select', {
    attrs: {
      "label": "Típus",
      "error-messages": _vm.errors.type_id,
      "items": _vm.types,
      "item-text": "name",
      "item-value": "id",
      "filled": "",
      "value-comparator": _vm.$config.comparators.isEqual
    },
    model: {
      value: _vm.controller.type_id,
      callback: function ($$v) {
        _vm.$set(_vm.controller, "type_id", $$v);
      },
      expression: "controller.type_id"
    }
  }), _c('v-select', {
    attrs: {
      "name": "Engedélyezve",
      "items": _vm.enabledSelectItems,
      "filled": "",
      "error-messages": _vm.enabledErrorMessage
    },
    model: {
      value: _vm.controller.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.controller, "enabled", $$v);
      },
      expression: "controller.enabled"
    }
  })], 1)], 1), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("Lokáció")]), _c('v-card-text', [_c('v-autocomplete', {
    attrs: {
      "label": "Épület",
      "error-messages": _vm.errors.building_id,
      "items": _vm.buildings,
      "item-text": "name",
      "item-value": "id",
      "filled": "",
      "value-comparator": _vm.$config.comparators.isEqual
    },
    model: {
      value: _vm.controller.building_id,
      callback: function ($$v) {
        _vm.$set(_vm.controller, "building_id", $$v);
      },
      expression: "controller.building_id"
    }
  }), _c('v-select', {
    attrs: {
      "label": "Épület szint",
      "error-messages": _vm.errors.building_level_id,
      "items": _vm.buildingLevels,
      "item-text": "name",
      "item-value": "id",
      "value-comparator": _vm.$config.comparators.isEqual,
      "filled": "",
      "disabled": !_vm.controller.building_id
    },
    model: {
      value: _vm.controller.building_level_id,
      callback: function ($$v) {
        _vm.$set(_vm.controller, "building_level_id", $$v);
      },
      expression: "controller.building_level_id"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Épület típus",
      "error-messages": _vm.errors.building_type,
      "filled": "",
      "placeholder": "B: épület, P: parkoló, BP vagy PB: mindkettő"
    },
    model: {
      value: _vm.controller.building_type,
      callback: function ($$v) {
        _vm.$set(_vm.controller, "building_type", $$v);
      },
      expression: "controller.building_type"
    }
  }), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": 12,
      "md": 6
    }
  }, [_c('v-masked-text-field', {
    attrs: {
      "label": "X koordináta",
      "error-messages": _vm.errors.x_coord,
      "filled": "",
      "mask": _vm.$config.inputMasks.floatNumber
    },
    model: {
      value: _vm.controller.x_coord,
      callback: function ($$v) {
        _vm.$set(_vm.controller, "x_coord", $$v);
      },
      expression: "controller.x_coord"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": 12,
      "md": 6
    }
  }, [_c('v-masked-text-field', {
    attrs: {
      "label": "Y koordináta",
      "error-messages": _vm.errors.y_coord,
      "filled": "",
      "mask": _vm.$config.inputMasks.floatNumber
    },
    model: {
      value: _vm.controller.y_coord,
      callback: function ($$v) {
        _vm.$set(_vm.controller, "y_coord", $$v);
      },
      expression: "controller.y_coord"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("Kapcsolat")]), _c('v-card-text', [_c('connection-form', {
    attrs: {
      "id": _vm.controller.connection_id,
      "errors": _vm.errors.connection
    },
    model: {
      value: _vm.controller.connection,
      callback: function ($$v) {
        _vm.$set(_vm.controller, "connection", $$v);
      },
      expression: "controller.connection"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-tab-item', {
    key: "gates",
    attrs: {
      "transition": false
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" Ajtók "), _c('v-spacer'), _c('v-btn', {
    staticClass: "ma-2 rounded-xl",
    attrs: {
      "color": "primary",
      "depressed": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.openGateEditorDialog('door');
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Új ajtó ")], 1)], 1), _c('v-card-text', [_vm.controller.doors.length === 0 ? _c('v-alert', {
    attrs: {
      "type": "info",
      "dense": ""
    }
  }, [_vm._v(" Jelenleg egy ajtó sincs ehhez a kontrollerhez rendelve. ")]) : _c('v-row', {
    staticClass: "mb-3",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.controller.doors, function (door) {
    return _c('v-col', {
      key: door.element_id,
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "4",
        "xl": "3"
      }
    }, [_c('gate-details', {
      attrs: {
        "gate": door,
        "building": _vm.selectedBuilding,
        "buildingLevel": _vm.selectedBuildingLevel,
        "type": 'door'
      },
      on: {
        "edit": function (gate) {
          return _vm.openGateEditorDialog('door', gate);
        }
      }
    })], 1);
  }), 1)], 1)], 1), _c('v-divider'), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" Forgóvillák "), _c('v-spacer'), _c('v-btn', {
    staticClass: "ma-2 rounded-xl",
    attrs: {
      "color": "primary",
      "depressed": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.openGateEditorDialog('turnstile');
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Új forgóvilla ")], 1)], 1), _c('v-card-text', [((_vm$controller$turnst = _vm.controller.turnstiles) === null || _vm$controller$turnst === void 0 ? void 0 : _vm$controller$turnst.length) === 0 ? _c('v-alert', {
    attrs: {
      "type": "info",
      "dense": ""
    }
  }, [_vm._v(" Jelenleg egy forgóvilla sincs ehhez a kontrollerhez rendelve. ")]) : _vm._e(), ((_vm$controller$turnst2 = _vm.controller.turnstiles) === null || _vm$controller$turnst2 === void 0 ? void 0 : _vm$controller$turnst2.length) > 0 ? _c('v-row', {
    staticClass: "mb-3",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.controller.turnstiles, function (turnstile) {
    return _c('v-col', {
      key: turnstile.element_id,
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "4",
        "xl": "3"
      }
    }, [_c('gate-details', {
      attrs: {
        "gate": turnstile,
        "controller": _vm.controller,
        "building": _vm.selectedBuilding,
        "buildingLevel": _vm.selectedBuildingLevel,
        "type": 'turnstile'
      },
      on: {
        "edit": function (gate) {
          return _vm.openGateEditorDialog('turnstile', gate);
        }
      }
    })], 1);
  }), 1) : _vm._e()], 1)], 1), _c('v-divider'), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" Sorompók "), _c('v-spacer'), _c('v-btn', {
    staticClass: "ma-2 rounded-xl",
    attrs: {
      "color": "primary",
      "depressed": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.openGateEditorDialog('barrier');
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Új sorompó ")], 1)], 1), _c('v-card-text', [_vm.controller.barriers.length === 0 ? _c('v-alert', {
    attrs: {
      "type": "info",
      "dense": ""
    }
  }, [_vm._v(" Jelenleg egy sorompó sincs ehhez a kontrollerhez rendelve. ")]) : _c('v-row', {
    staticClass: "mb-3",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.controller.barriers, function (barrier) {
    return _c('v-col', {
      key: barrier.element_id,
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "4",
        "xl": "3"
      }
    }, [_c('gate-details', {
      attrs: {
        "gate": barrier,
        "controller": _vm.controller,
        "building": _vm.selectedBuilding,
        "buildingLevel": _vm.selectedBuildingLevel,
        "type": 'barrier'
      },
      on: {
        "edit": function (gate) {
          return _vm.openGateEditorDialog('barrier', gate);
        }
      }
    })], 1);
  }), 1)], 1)], 1)], 1), _c('v-tab-item', {
    key: "accumulators",
    attrs: {
      "transition": false
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" Akkumulátorok "), _c('v-spacer'), _c('v-btn', {
    staticClass: "ma-2 rounded-xl",
    attrs: {
      "color": "primary",
      "depressed": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.openAccumulatorEditorDialog();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Új akkumulátor ")], 1)], 1), _c('v-data-table', {
    attrs: {
      "loading": _vm.loading,
      "headers": _vm.dataTable.headers,
      "items": this.dataTable.items,
      "options": _vm.dataTable.options,
      "footer-props": _vm.$config.dataTableFooterProps,
      "calculate-widths": "",
      "disable-pagination": "",
      "hide-default-footer": ""
    },
    on: {
      "update:options": function ($event) {
        return _vm.$set(_vm.dataTable, "options", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: `item.active`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('v-chip', {
          attrs: {
            "color": item.active == 1 ? 'success' : 'error'
          }
        }, [_vm._v(" " + _vm._s(item.active == 1 ? 'Használatban' : 'Selejtezve') + " ")])];
      }
    }, {
      key: `item.installation_date`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.formatDateOnly(item.installation_date)) + " ")];
      }
    }, {
      key: `item.replacement_due_date`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [item.replacement_due_date ? _c('div', [_vm._v(_vm._s(item.replacement_due_date) + " év")]) : _c('div', {
          staticClass: "text--disabled"
        }, [_vm._v("-")])];
      }
    }, {
      key: `item.voltage`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('div', {
          staticStyle: {
            "padding-left": "16px"
          }
        }, [_vm._v(_vm._s(item.voltage) + " V")])];
      }
    }], null, true)
  })], 1)], 1), _vm.controller.enabled > 0 ? _c('v-tab-item', {
    key: "debug",
    attrs: {
      "transition": false
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("Hibakeresés")]), _c('v-card-text', [_c('debug-info', {
    attrs: {
      "controller": _vm.controller,
      "is-dsc-debug": _vm.controller.enabled == 1
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 2)], 1), _c('door-editor-dialog', {
    key: _vm.gateEditorDialog.key,
    attrs: {
      "gate-type": _vm.gateEditorDialog.gateType,
      "controller": _vm.controller,
      "gate": _vm.gateEditorDialog.gate
    },
    on: {
      "save": _vm.fetchController
    },
    model: {
      value: _vm.gateEditorDialog.isOpen,
      callback: function ($$v) {
        _vm.$set(_vm.gateEditorDialog, "isOpen", $$v);
      },
      expression: "gateEditorDialog.isOpen"
    }
  }), _c('accumulator-dialog', {
    key: `accumulator-${_vm.accumulatorDialog.key}`,
    attrs: {
      "controllerId": _vm.controller.element_id
    },
    on: {
      "save": _vm.fetchController
    },
    model: {
      value: _vm.accumulatorDialog.isOpen,
      callback: function ($$v) {
        _vm.$set(_vm.accumulatorDialog, "isOpen", $$v);
      },
      expression: "accumulatorDialog.isOpen"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }